import React, { useState, useEffect } from 'react';

interface CookiesFor {
    cr_session?: string;
    userToken?: string;
    profileid?: string;
    mws_profileid?: string;
    claro_profileid?: string;
    prof_profileid?: string;
    tnube_profileid?: string;
}

function useCookies() {
    const [cookies, setCookies] = useState<CookiesFor>({});
    useEffect(() => {
        setCookies(document.cookie.split(';').reduce((p, c) => {const [key, val] = c.split('='); p[key.split(' ').join('')] = val; return p}, {}))
    }, []);

    return cookies;
}

export default useCookies;